<div class="grid-img-background"
*ngIf="avatar"
[ngStyle]="{ 'background-image': 'url('+ (avatar) +')',
              'height':height+'px',
              'width':width+'px',
              'border-radius':borderRadius+'%' }">

</div>

<div class="grid-img-background"
*ngIf="!avatar"
[ngStyle]="{ 'background-image': 'url('+ 'https://firebasestorage.googleapis.com/v0/b/festivali.appspot.com/o/projects%2F4e17YfYSZVMhzJev5WCey%2Fassets%2Favatar.jpeg?alt=media&token=a7334b75-1b7a-42f8-bd3f-404d824a5d6b
' +')',
              'height':height+'px',
              'width':width+'px',
              'border-radius':borderRadius+'%' }">

</div>

